const redReflex =[

    {label:"Side",
    controlType:"radio button",
    options:["Right", "Left", "Bilateral"]
    },

    {label:"Colour",
    controlType:"radio button",
    options:["White", "Yellow", "Black"]
    },

    {label:"Vision in affected eye",
    controlType:"radio button",
    options:["Normal vison", "Blurred vision", "Abscent vision"]
    },

    {label:"Eye inflammed",
    controlType:"radio button",
    options:["Inflammed", "Not inflammed"]
    },
    
]

export default redReflex